import React from "react";
import styles from "./index.module.scss";
import { CircularProgress } from "@mui/material";

function Loader() {
  return (
    <div className={styles["loader-wrapper"]}>
      <CircularProgress
        sx={{ color: "#171C8F" }}
        size={(2.5 * window.visualViewport.height) / 100}
      />
    </div>
  );
}

export default Loader;
